import React, { useEffect, useMemo } from 'react';
import { PULSE_ISSUER } from '../pulsePrint';
import { readReceiptPrint } from '../payments';
import { formatGmdAmount, formatMsisdn, PULSE_WAVE_DISPLAY } from '../wallets';

function ReceiptPrint() {
    const payload = useMemo(() => readReceiptPrint(), []);
    const receipt = payload && payload.receipt;
    const companyName = (payload && payload.companyName) || (receipt && receipt.companyName) || 'Pulse Insurance';

    useEffect(() => {
        if (!receipt) return;
        const t = window.setTimeout(() => window.print(), 400);
        return () => window.clearTimeout(t);
    }, [receipt]);

    if (!receipt) {
        return <div className="p-4">No receipt is ready to print.</div>;
    }

    return (
        <div className="container py-4" style={{ maxWidth: 560 }}>
            <style>{`
                @media print { .no-print { display: none !important; } body { background: #fff; } }
            `}</style>
            <div className="no-print mb-3">
                <button type="button" className="btn btn-primary" onClick={() => window.print()}>Print receipt</button>
            </div>
            <div className="border p-4">
                <div className="text-uppercase small text-muted">{PULSE_ISSUER.name}</div>
                <h4 className="mb-0">{companyName}</h4>
                <div className="small text-muted mb-3">{PULSE_ISSUER.address}, {PULSE_ISSUER.locality} Tel {PULSE_ISSUER.tel}</div>
                <h5>Premium receipt</h5>
                <table className="table table-sm">
                    <tbody>
                        <tr><th>Receipt</th><td>{receipt.receiptNo}</td></tr>
                        <tr><th>Policy</th><td>{receipt.policyNumber}</td></tr>
                        <tr><th>Insured</th><td>{receipt.holderName || '—'}</td></tr>
                        <tr><th>Plate</th><td>{receipt.plate || '—'}</td></tr>
                        <tr><th>Amount</th><td>{formatGmdAmount(receipt.amountGMD)}</td></tr>
                        <tr><th>Method</th><td>{receipt.walletBrand || receipt.paymentMethod}</td></tr>
                        <tr><th>Paid to</th><td>{receipt.walletNumber || formatMsisdn(PULSE_WAVE_DISPLAY)}</td></tr>
                        <tr><th>Reference</th><td>{receipt.reference || '—'}</td></tr>
                        <tr><th>Date</th><td>{receipt.paidAt ? new Date(receipt.paidAt).toLocaleString() : '—'}</td></tr>
                        <tr><th>Received by</th><td>{receipt.recordedByName || '—'}</td></tr>
                    </tbody>
                </table>
                <p className="small mb-0">Keep this receipt with your certificate. Police can check cover at pulse-insurance.web.app/verify</p>
            </div>
        </div>
    );
}

export default ReceiptPrint;
